import React, { useRef, useEffect } from "react";

function Search({ setSearchLocation }) {
  const inputEl = useRef(null);

  const searchLocation = () => {
    setSearchLocation(inputEl.current.value);
  };

  useEffect(() => {
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        setSearchLocation(inputEl.current.value);
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [setSearchLocation]);

  return (
    <div className="search-container">
      <input
        ref={inputEl}
        className="input-field"
        type="text"
        placeholder="Enter a location"
      />

      <button onClick={searchLocation} className="search-btn">
        Search
      </button>
    </div>
  );
}

export default Search;
